import { render, staticRenderFns } from "./MyWithdrawTab.vue?vue&type=template&id=866cf00a"
import script from "./MyWithdrawTab.vue?vue&type=script&lang=js"
export * from "./MyWithdrawTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports